import React, { MouseEvent, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";

interface Props {
    path: string,
    label?: string,
    allowedFiles: string[]
}

const FileUploadWithLocationUrlField = ({
    path,
    label,
    allowedFiles,
} : Props) => {
    const { register, getValues } = useFormContext();
    const { ref, ...rest } = register(path);
    const fileUploadElementRef = useRef<HTMLInputElement>(null);
    const fileValue = getValues(path);
    const [ fileLocation ] = useState(fileValue);
    const [ isFileLocationPresent, setIsFileLocationPresent ] = useState<boolean>(!!fileValue);

    const toggleFileUploadView = (e: MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        if (fileUploadElementRef.current) {
            fileUploadElementRef.current.value = "";
        }
        setIsFileLocationPresent(!isFileLocationPresent);
    };

    return (
        <div key = {path} className={`flex flex-col gap-2`}>
            <label className = {`dark:text-gray-100 mb-1`}>{label}</label>
            {
                <div className={"flex gap-2"}>
                    {
                        !isFileLocationPresent ?
                        <input
                            {...rest}
                            ref = {(el) => {
                                ref(el);
                                fileUploadElementRef.current = el;
                            }}
                            type="file"
                            className={
                                `cursor-pointer file:bg-gray-300 file:border-0 file:font-semibold dark:file:bg-brand-900 bg-gray-300 dark:bg-brand-900 w-full p-2 rounded-md 
                                                dark:file:text-gray-100`
                            }
                            accept={allowedFiles.join(",")}
                        />
                            :
                            <div className="px-2 py-1 w-full bg-gray-300 dark:bg-brand-900 rounded-md">
                                <a target={"_blank"} href={fileLocation} className="inline-block truncate underline flex-1 min-w-0 text-brand-300" rel="noreferrer">{fileLocation}</a>
                            </div>

                    }
                    {
                        (!!fileLocation && typeof fileLocation === "string") &&
                        <button
                            onClick={e => toggleFileUploadView(e)}
                            className={"shrink-0 px-2 bg-gray-300 dark:bg-brand-300 rounded-md font-bold"}
                        >
                            {!isFileLocationPresent ? "Cancel" : "Replace"}
                        </button>
                    }
                </div>

            }
        </div>
    );
};

export default FileUploadWithLocationUrlField;